import { styled } from "@mui/material/styles";
import BreakPoints from "src/general/constants/breakPoints";
import Colors from "../../../general/constants/colors";

export const LayoutContainer = styled("div")({
	backgroundColor: Colors.GREY_OLD,
	display: "flex",
	flexDirection: "column",
	minHeight: "100vh",
	width: "100%",
});

export const ContentWrapper = styled("main")({
	display: "flex",
	flex: 1,
	alignItems: "center",
	justifyContent: "center",
	width: "100%",
});

export const CenteredContent = styled("div")({
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	justifyContent: "center",
	width: "100%",
});

export const FixAdaptiveAuthPage = styled("div")(() => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	height: "774px",
	maxWidth: "500px",
	boxSizing: "border-box",
	[`@media (min-width: ${BreakPoints.LARGE_1439}px) and (max-width: ${BreakPoints.FHD_1919}px)`]:
		{
			height: "762px",
		},

	[`@media (min-width: ${BreakPoints.MOBILE_767}px) and (max-width: ${BreakPoints.LARGE_1439}px)`]:
		{
			height: "750px",
			width: "400px",
		},
	[`@media (min-width: ${BreakPoints.TAPOK_319}px) and (max-width: ${BreakPoints.MOBILE_767}px)`]:
		{ height: "736px", width: "343px" },
}));
